const depoiments = [
    {
        title: "Provérbios 15:33",
        content:
        "O temor do SENHOR é a instrução da sabedoria, e precedendo a honra vai a humildade",
    },
    {
        title: "Salmo 121:8",
        content:
        "O Senhor guardará a tua saída e a tua entrada, desde agora e para sempre.",
    },
    {
        title: "João 8:12",
        content:
        "Disse-lhes Jesus: Eu sou a luz do mundo; quem me segue não andará em trevas, mas terá a luz da vida.",
    },
    {
        title: "Coríntios 4:17",
        content:
        "Porque a nossa leve e momentânea tribulação produz para nós cada vez mais abundantemente um eterno peso de glória.",
    },
    {
        title: "Romanos 15:13",
        content:
        "Ora, o Deus de esperança vos encha de todo o gozo e paz na vossa fé, para que abundeis na esperança pelo poder do Espírito Santo.",
    },
];

export default depoiments;
